import { PaginatedResult } from "@/Core/Client";
import { EventResponseDto } from "@/Dtos/event-dto";
import EventCalendarView from "./event-calendar";

export default function EventCalendarPage({ data }: { data: PaginatedResult<EventResponseDto> }) {
    return <EventCalendarView data={data} />;
}

